<template>
    <div v-if="store.specifications.length > 0" class="container px-0">
        <table class="table table-borderless lh-1">
            <tbody>
            <tr v-for="field in store.specifications" :key="field.id">
                <td class="fw-bold pb-0 w-50 ps-0" v-html="field.name"></td>
                <td class="pb-0 ps-0" v-html="field.value"></td>
            </tr>
            </tbody>
        </table>

        <div class="row mb-1" v-if="product.fine_weight > 0">
            <small>
                <sup>1</sup>
                {{ $t(
                'The weight displayed is the fine metal content of the item. It does not reflect the actual weight of the product which may be higher.'
            ) }}
            </small>
        </div>

        <div class="row mb-1 text-danger">
            <small>
                <sup>*</sup>
                {{ $t(
                'The delivered products may vary slightly from the picture shown.'
            ) }}
            </small>
        </div>
    </div>
</template>

<script setup>
import { useProductPageStore } from "~/stores/ProductPageStore";

const store = useProductPageStore();

const props = defineProps({
    product: {
        required: true,
        type: Object
    }
});

</script>
